import { type ReactNode } from 'react';

import { Button, type ButtonVariant } from '@common/atoms/Button';
import { BaseModalType, useModalContext } from '@common/organisms/BaseModal';

interface Props {
    children: ReactNode;
    variant?: ButtonVariant;
    contextKey?: BaseModalType | string;
}

export const OpenModalButton = ({
    children,
    variant = 'filled-primary',
    contextKey = BaseModalType.Default,
    ...rest
}: Props) => {
    const { openModal } = useModalContext(contextKey);

    return (
        <Button variant={variant} onClick={openModal} {...rest}>
            {children}
        </Button>
    );
};
